import React, { createContext, useEffect, useState } from "react";

const ProcesoMatriculaContext = createContext();

const ProcesoMatriculaProvider = ({ children }) => {
  const [seleccionPdf, setSeleccionPdf] = useState({});
  const [listadoDatosPersonales, setListadoDatosPersonales] = useState([]);
  const [ckeckValidator, setCkeckValidator] = useState(false);
  const [obtenerReglamentoEstudios, setObtenerReglamentoEstudios] = useState(
    []
  );
  const [obtenerSegurosAccidentes, setObtenerSegurosAccidentes] = useState([]);
  const [
    obtenerEmpresasSegurosAccidentes,
    setObtenerEmpresasSegurosAccidentes,
  ] = useState([]);
  const [
    obtenerSegurosAccidentesEstudiante,
    setObtenerSegurosAccidentesEstudiante,
  ] = useState([]);
  const [pasoProcesoM, setPasoProcesoM] = useState(0);
  const [pasoSegundaVistaProcesoM, setPasoSegundaVistaProcesoM] =
    useState(false);


  const [celular, setCelular] = useState(0);
  const [correo, setCorreo] = useState(0);


  const [listadoAsignaturasEstudiante, setListadoAsignaturasEstudiante] =
    useState([]);

  const [listEventos, setListEventos] = useState([]);
  const [cambiarTextoBoton, setCambiarTextoBoton] = useState(false);

  const [listAsignaturasAgregadas, setListAsignaturasAgregadas] = useState([]);
  const [validarListaHorario, setValidarListaHorario] = useState([]);

  const [strInsertarHorario, setStrInsertarHorario] = useState([]);

  const [loading, setLoading] = useState(false);

  const [msgModalHorario, setMsgModalHorario] = useState({});

  const [carritoHorario, setCarritoHorario] = useState({});

  const [archivoPeso, setArchivoPeso] = useState({});

  const [resumenPagoEstudiante, setResumenPagoEstudiante] = useState([]);
  const [listaPensionesEstudiante, setPensionesEstudiante] = useState([]);
  const [cuotasPagosEstudiante, setCuotasPagosEstudiante] = useState([]);
  const [stCuotaSelecionada, setCuotaSeleccionada] = useState("");
  const [listadoBancos, setListadoBancos] = useState([]);
  const [listadoModalidadPagos, setListadoModalidadPagos] = useState({})

  const [errorServices, setErrorServices] = useState(false);
  const [errorCursoServices, setErrorCursoServices] = useState("");
  return (
    <ProcesoMatriculaContext.Provider
      value={{
        seleccionPdf,
        setSeleccionPdf,
        listadoDatosPersonales,
        setListadoDatosPersonales,
        ckeckValidator,
        setCkeckValidator,
        obtenerReglamentoEstudios,
        setObtenerReglamentoEstudios,
        obtenerSegurosAccidentes,
        setObtenerSegurosAccidentes,
        obtenerEmpresasSegurosAccidentes,
        setObtenerEmpresasSegurosAccidentes,
        obtenerSegurosAccidentesEstudiante,
        setObtenerSegurosAccidentesEstudiante,
        ckeckValidator,
        setCkeckValidator,
        pasoProcesoM,
        setPasoProcesoM,
        pasoSegundaVistaProcesoM,
        setPasoSegundaVistaProcesoM,
        celular,
        setCelular,
        correo,
        setCorreo,
        listadoAsignaturasEstudiante,
        setListadoAsignaturasEstudiante,
        listEventos,
        setListEventos,
        cambiarTextoBoton,
        setCambiarTextoBoton,
        listAsignaturasAgregadas,
        setListAsignaturasAgregadas,
        validarListaHorario,
        setValidarListaHorario,
        strInsertarHorario, setStrInsertarHorario,
        loading, setLoading,
        resumenPagoEstudiante,
        setResumenPagoEstudiante,
        listaPensionesEstudiante,
        setPensionesEstudiante,
        cuotasPagosEstudiante,
        setCuotasPagosEstudiante,
        stCuotaSelecionada,
        setCuotaSeleccionada,
        msgModalHorario, setMsgModalHorario,
        carritoHorario, setCarritoHorario,
        listadoBancos, setListadoBancos,
        archivoPeso, setArchivoPeso,
        errorServices, setErrorServices,
        listadoModalidadPagos, setListadoModalidadPagos,
        errorCursoServices, setErrorCursoServices
      }}
    >
      {children}
    </ProcesoMatriculaContext.Provider>
  );
};
export { ProcesoMatriculaContext };
export default ProcesoMatriculaProvider;
